import { Criteria, ensureJson, IListResult, RestClient } from 'slipstream-components';
import { convertServiceResult } from 'ui-common';
import MyProfileEntity from '../entities/MyProfileEntity';

const restClient = new RestClient();
const myProfileAPI = {
  async getProfile(payload: any) {
    const response = await restClient.post('/iamsvc/get-user', payload);
    const result = ensureJson(response.body).output;
    return result;
  },

  async updateUser(payload: any) {
    return restClient.post('/iamsvc/edit-user', payload);
  },

  async changePassword(userId: string, userName: string, oldPassword: string, password: string) {
    const postObj = {
      input: {
        user_id: userId,
        user_name: userName,
        old_password: oldPassword,
        new_password: password,
      },
    };
    return restClient.post('/iamsvc-noauth/change-password/', postObj);
  },

  async getMfaSettings(payload: any) {
    const response = await restClient.post('/iamsvc/get-user', payload);
    const result = ensureJson(response.body).output;
    return result;
  },

  async getQRCodeUri() {
    const payload = { input: {} };
    const response = await restClient.post('/iamsvc/generate-totp-uri', payload);
    const result = ensureJson(response.body).output;
    return result;
  },

  async toggleMfa(payload): Promise<any> {
    return restClient.post('/iamsvc/configure-mfa', payload).then((result: any) => {
      return result;
    });
  },
  async toggleMfaScope(payload): Promise<any> {
    return restClient.post('/iamsvc/configure-mfa-for-scope', payload).then((result: any) => {
      return result;
    });
  },

  async enableTOTP(): Promise<boolean> {
    const payload = { input: { mfa_method: 'TOTP' } };
    return restClient.post('/iamsvc/configure-mfa-method', payload).then((result: any) => {
      return result;
    });
  },

  async disableTOTP(): Promise<boolean> {
    const payload = { input: { mfa_method: 'TOTP' } };
    return restClient.post('/iamsvc/revoke-mfa-method', payload).then((result: any) => {
      return result;
    });
  },

  async verifyMfaCode(payload): Promise<boolean> {
    return restClient.post('/iamsvc/verify-mfa-code', payload).then((result: any) => {
      return result;
    });
  },
};

export default myProfileAPI;
